module.exports = "<ng-progress [thick]=\"true\" [showSpinner]=\"false\" [color]=\"'blue'\"></ng-progress>\n\n\n"